import React from 'react';
import { projects } from '../data/mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Lightbulb, Users, Heart, Brain } from 'lucide-react';

const Projects = () => {
  const getIcon = (index) => {
    const icons = [Users, Heart, Lightbulb, Brain];
    return icons[index % icons.length];
  };

  return (
    <section id="projects" className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Community Initiatives & Research
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Leading innovative projects for cancer prevention, early detection, and patient support
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => {
            const Icon = getIcon(index);
            return (
              <Card key={project.id} className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                      <Icon className="w-7 h-7 text-teal-700" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-xl mb-2">{project.name}</CardTitle>
                      <Badge variant="outline" className="text-xs border-teal-700 text-teal-700">
                        {project.role}
                      </Badge>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base mb-4">{project.description}</CardDescription>
                  <div className="bg-teal-50 rounded-lg p-4">
                    <p className="text-sm font-semibold text-teal-900 mb-1">Impact:</p>
                    <p className="text-sm text-teal-800">{project.impact}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Projects;